/* HIS OWN — the returning man.
   Loaded AFTER the engine parts.

   The assessment had no memory. A refresh lost everything, and a man who came
   back was asked to answer twenty-seven questions again to see a report he had
   already earned. This stores a completed run on his own device, greets him
   with it, and offers a re-take rather than a first take.

   It also makes the day-52 re-score possible, which needs day-0 answers to
   still exist somewhere.

   WHERE IT IS STORED. localStorage, on his device only. Nothing here is sent
   anywhere — the engine's own POST already did that. Because the answers
   include androgen use, drugs and sexual history, the greeting carries a
   one-click delete, and we say plainly that it is stored. A shared phone is
   the normal case in this market, not the exception. */
(function () {
  'use strict';

  var KEY = 'ho_runs_v1';
  var MAX = 3;                    // enough for a day-0, a day-52 and a day-90

  function safe(fn, f) { try { return fn(); } catch (e) { return f; } }
  function load() { return safe(function () { return JSON.parse(localStorage.getItem(KEY)) || []; }, []); }
  function save(a) { safe(function () { localStorage.setItem(KEY, JSON.stringify(a.slice(-MAX))); }); }
  function wipe() { safe(function () { localStorage.removeItem(KEY); }); }

  function when(ts) {
    var d = Math.floor((Date.now() - ts) / 86400000);
    if (d <= 0) return 'today';
    if (d === 1) return 'yesterday';
    if (d < 30) return d + ' days ago';
    if (d < 60) return 'about a month ago';
    return Math.round(d / 30) + ' months ago';
  }

  /* ---------- saving ---------- */

  function snapshot() {
    return safe(function () {
      var R = scores();
      var raw = {};
      Object.keys(SIDX).forEach(function (id) {
        var v = ans[SIDX[id]];
        if (v !== undefined) raw[id] = v;
      });
      return {
        v: 1,
        at: Date.now(),
        answers: raw,
        scores: R.s,
        routes: R.routes,
        protocol: (typeof protocolOf === 'function') ? protocolOf(R) : null,
        modules: ((typeof modules === 'function') ? modules(R) : []).map(function (m) { return m.c; })
      };
    }, null);
  }

  var saved = false;
  function saveRun() {
    if (saved) return;
    var snap = snapshot();
    if (!snap || !Object.keys(snap.answers).length) return;
    saved = true;
    var runs = load();
    /* a re-render of the same report is not a second run */
    var last = runs[runs.length - 1];
    if (last && snap.at - last.at < 6 * 3600000) runs[runs.length - 1] = snap;
    else runs.push(snap);
    save(runs);
  }

  /* ---------- restoring ---------- */

  function restore(run) {
    return safe(function () {
      Object.keys(ans).forEach(function (k) { delete ans[k]; });
      Object.keys(run.answers).forEach(function (id) {
        if (SIDX[id] !== undefined) ans[SIDX[id]] = run.answers[id];
      });
      var idx = -1;
      for (var n = 0; n < S.length; n++) if (S[n].t === 'result') { idx = n; break; }
      if (idx === -1) return false;
      window.i = idx;
      render();
      return true;
    }, false);
  }

  /* ---------- the greeting ---------- */

  function greet(run) {
    var inner = document.getElementById('inner');
    var foot = document.querySelector('.stage-foot');
    if (!inner) return;

    var top = '', best = -1;
    safe(function () {
      Object.keys(run.scores).forEach(function (d) {
        if (run.scores[d] > best) { best = run.scores[d]; top = DOMNAME[d]; }
      });
    });

    var line = run.routes && run.routes.length
      ? 'Your last report sent you to a doctor rather than a protocol.'
      : (run.protocol ? 'It named ' + run.protocol.replace(/^The /, 'the ') + '.'
                      : (top ? 'Your ' + top.toLowerCase() + ' score came back highest.' : ''));

    var h = '';
    h += '<div class="mark">WELCOME BACK</div>';
    h += '<div class="big" style="font-size:38px">You have already<br><em>done this.</em></div>';
    h += '<p class="lede">You completed the assessment <strong>' + when(run.at) + '</strong>. ' + line +
         ' Nothing has been lost — your answers are still here on this device.</p>';
    h += '<div class="vblock"><div class="vlab">WHEN TO TAKE IT AGAIN</div><p>Sperm take about ' +
         'seventy-four days to make, so a re-take inside three months mostly measures noise. ' +
         'Day 52 is the exception: far enough in to show whether the protocol is working, early ' +
         'enough to change it.</p></div>';
    h += '<div class="pacts" style="margin-top:28px">' +
         '<button class="next accent" id="ho-open-last" type="button">OPEN MY LAST REPORT</button>' +
         '<button class="pact-save" id="ho-retake" type="button">RETAKE THE ASSESSMENT</button>' +
         '</div>';
    h += '<div class="pact-note">Answers stored on this device only, never in the page you might ' +
         'share. <a href="#" id="ho-forget">Delete them from this device</a>.</div>';

    inner.innerHTML = h;
    if (foot) foot.style.display = 'none';

    document.getElementById('ho-open-last').addEventListener('click', function () {
      if (foot) foot.style.display = '';
      if (!restore(run)) { if (foot) foot.style.display = ''; render(); }
    });
    document.getElementById('ho-retake').addEventListener('click', function () {
      if (foot) foot.style.display = '';
      window.i = 0; render();
    });
    document.getElementById('ho-forget').addEventListener('click', function (e) {
      e.preventDefault();
      wipe();
      if (foot) foot.style.display = '';
      window.i = 0; render();
    });
  }

  /* ---------- wiring ---------- */

  function boot() {
    var inner = document.getElementById('inner');
    if (!inner) return;

    safe(function () {
      new MutationObserver(function () {
        if (inner.querySelector('.scorewrap')) saveRun();
      }).observe(inner, { childList: true, subtree: true });
    });

    var runs = load();
    var last = runs[runs.length - 1];
    var forced = safe(function () {
      return /(^|[?&])retake=1/.test(window.location.search);
    }, false);

    /* only greet at the very start. Mid-quiz, the man is already working. */
    if (last && !forced && window.i === 0) setTimeout(function () { greet(last); }, 0);

    window.HO_HAS_RESULT = !!last;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
